export default (filters: any) => {
  const usedFilters = Object
    .keys(filters)
    .filter((key: any) => filters[key]);
  return usedFilters
    .reduce((acc, filter) => acc + `${filter}=${typeof filters[filter] === 'object' ? JSON.stringify(filters[filter]) : filters[filter]}&`, '')
    .slice(0, -1);
}